var scope_0 = require('/opt/build/repo/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2fe956217aed3411cfaea06147fec759.js').default;export default
        Object.assign({}, scope_0 )
    